import React from 'react';
import { Row, Col, Form, FormGroup, Input, Label } from 'reactstrap';

import Body from '../Components/layout/Body';
import LoginNotice from './LoginNotice';

const REQUEST_CLIENT_HELP = `
<div>
  <p>Here is where you can request shared access to an existing client. For example, you may have a colleague who has already worked with a particular client within Access Navigator. Now you want to work with this same client, and share the data with your colleague. 
  To do that, you would request access to that client from your colleague. Once your colleague receives and confirms the request, that client will then appear in your list of clients.</p>
  <p>The Client Username is the client's official username within Access Navigator. Get the client's username from someone who already has access to this client.</p>
  <p><strong>Note: </strong>Be careful to enter the client's username correctly. Access Navigator won't be able to tell if the username is incorrect until your colleague tries to confirm the request.</p>
  <p>The Current Provider Email is used to email a current provider and request access to the client. This person will receive an email with the link to approve your request for access. This field is optional, as there are other ways to request access instead of email.</p>
  <p>Hit Continue to view and share the request. There are actually 4 options for how to share the request: </p>
  <ol>
    <li><strong>Share: </strong>This opens up the sharing options in your device. For example, on an iPad, tap the Messages option to open up a text message that includes the request. Then send the text message to your colleague.</li> 
    <li><strong>Copy Full Request: </strong>This copies the full request message onto your clipboard. From there, you can paste it into an email, text message, or other app to send to your colleague.</li> 
    <li><strong>Copy Link Only: </strong>If you want something more streamlined, this copies only the request link onto your clipboard. From there, you can paste it into an email, text message, or other app to send to your colleague.</li> 
    <li><strong>Email Request: </strong>This opens your email app (if available) and sends the request message to the email address you supplied.</li> 
  </ol>
  <p>Mainly what you need is to send the link in the request message to your colleague, in whatever way you prefer. They in turn need to click that link to execute the request.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersRequestAccessContent(props) {
  const {
    loggedIn,
    currentClinicianEmail,
    onChangeCurrentClinicianEmail,
    usernameToRequest,
    onChangeUsernameToRequest
  } = props;

  //this page is active only if you are logged in as practitioner
  return(
    <>
    <p>You can request shared access to a client who already exists in Access Navigator. You need to know two things: </p>
    <ol>
      <li>the client's official username within Access Navigator</li>
      <li>the practitioner who already has access to that client</li>
    </ol>
    {!loggedIn &&
      <LoginNotice message="To request client access, you first need to " />
    }
    <Row className="aa-review-row">
      <Col>
        <Form>
          <FormGroup>
            <Label for="usernameToRequest" className='aa-bold-text'>
              Client Username <span className="aa-field-required">*</span>
            </Label>
            <Input
              id="usernameToRequest"
              value={usernameToRequest || ''}
              onChange={onChangeUsernameToRequest}
              name="usernameToRequest"
              type="textfield"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="currentClinicianEmail" className='aa-bold-text'>
              Current Practitioner Email <span className="aa-more-info">(Optional. Enter this to send the request via email.)</span>
            </Label>
            <Input
              id="currentClinicianEmail"
              value={currentClinicianEmail || ''}
              onChange={onChangeCurrentClinicianEmail}
              name="currentClinicianEmail"
              type="textfield"
            />
          </FormGroup>
        </Form>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    <p>Hit Continue to view and share your request with the other practitioner.</p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersRequestAccess(props) {
  const {
    loggedIn,
    currentClinicianEmail,
    usernameToRequest,
    onChangeCurrentClinicianEmail,
    onChangeUsernameToRequest,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Request Access to Another Client",
    subTitle: "",
    learnMore: {linkText: "Learn More about requesting client access",
                title: "Requesting access to another client",
                content: REQUEST_CLIENT_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("***rendering UsersRequestAccess, props: " + JSON.stringify(props));

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersRequestAccessContent 
          loggedIn={loggedIn}
          currentClinicianEmail={currentClinicianEmail}
          onChangeCurrentClinicianEmail={onChangeCurrentClinicianEmail}
          usernameToRequest={usernameToRequest}
          onChangeUsernameToRequest={onChangeUsernameToRequest}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersRequestAccess;